export default __webpack_public_path__ + "static/media/share-story-2.facf728e.png";